import { render } from "./GAElectionView.vue?vue&type=template&id=4b2bf6b0&scoped=true"
import script from "./GAElectionView.vue?vue&type=script&lang=js"
export * from "./GAElectionView.vue?vue&type=script&lang=js"

import "./GAElectionView.vue?vue&type=style&index=0&id=4b2bf6b0&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2bf6b0"]])

export default __exports__